import { render, staticRenderFns } from "./PengaturanIcon.vue?vue&type=template&id=20c51311"
import script from "./PengaturanIcon.vue?vue&type=script&lang=js"
export * from "./PengaturanIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports